export interface MsgResult
{
    message:string,
    success:boolean,
    optionalParameters?:string[]
}
